import { useEffect, useState } from 'react';
import { useMe } from '../me';
import { toggleWorldPin, worldPins } from './world-missions';

export function useWorldPins() {
  const me = useMe();
  const key = me?.userId ? `symphony.world.pinnedGoals.${me.userId}` : null;
  const [saved, setSaved] = useState<{ key: string | null; ids: string[] }>({ key: null, ids: [] });
  const ids = saved.key === key ? saved.ids : [];
  useEffect(() => {
    const read = () => {
      let ids: string[] = [];
      try { if (key) ids = worldPins(JSON.parse(localStorage.getItem(key) || '[]')); } catch { /* Unavailable storage keeps this visit usable. */ }
      setSaved({ key, ids });
    };
    read();
    const storage = (event: StorageEvent) => { if (event.key === key || event.key === null) read(); };
    window.addEventListener('storage', storage);
    return () => window.removeEventListener('storage', storage);
  }, [key]);
  const save = (ids: string[]) => {
    if (!key) return;
    setSaved({ key, ids });
    try { localStorage.setItem(key, JSON.stringify(ids)); } catch { /* Pins still work for this visit. */ }
  };
  return { ids, ready: !!key && saved.key === key, toggle: (id: string) => save(toggleWorldPin(ids, id)), clear: () => save([]) };
}
